export class VcallQuestionTypeClosingDetail {
  endCallPopupText: string;
}
